
import Card from '../../../components/base/Card';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-restaurant-line',
      title: 'Private Dining',
      description: 'Intimate dinner experiences crafted in the comfort of your own home with personalized menus and professional service.',
      features: ['Custom menus', 'Professional service', 'Dietary accommodations', 'Wine pairings']
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Event Catering',
      description: 'Exceptional catering for special occasions, corporate events, and celebrations with full-service options.',
      features: ['Wedding catering', 'Corporate events', 'Birthday parties', 'Holiday celebrations']
    },
    {
      icon: 'ri-fire-line',
      title: 'Braai Masters',
      description: 'Authentic South African braai experiences with traditional techniques and premium local ingredients.',
      features: ['Traditional braai', 'Premium meats', 'Local specialties', 'Outdoor cooking']
    },
    {
      icon: 'ri-book-open-line',
      title: 'Cooking Classes',
      description: 'Learn from the masters with hands-on cooking classes in various cuisines and techniques.',
      features: ['Hands-on learning', 'Small groups', 'Recipe cards', 'Technique mastery']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-emerald-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From intimate private dinners to large celebrations, our chefs provide 
            exceptional culinary experiences tailored to your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card key={index} hover className="p-6 text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-6">
                <i className={`${service.icon} text-2xl text-emerald-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <div className="w-4 h-4 flex items-center justify-center mr-2">
                      <i className="ri-check-line text-emerald-600 text-xs"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
